export default {
    create_company: 'Odaberite vaš subdomen',
    invoice_info: 'Faktura se šalje svakog prvog u mesecu za prethodni mesec',
    congratulations: 'Čestitamo!',
    became_a_partner: 'Postali ste Bookeraj partner',
    partner_info_one:
        'Bitno je da znate da u svakom momentu možete da se odjavite ili promenite plan. Izmene nad planom postaće aktivne od 1. u sledećem mesecu',
    partner_info_two:
        'Ukoliko Vam je potrebna pomoć osećajte se slobodno da nas kontaktirate na našoj kontakt stranici ili putem društvenih mreža.',
    go_to_your_company: 'Idite na vašu kompaniju',
    enter_subdomain: 'Unesite svoj subdomen',
    subdomain: 'Subdomen',
    subdomain_footnote: 'Unosom subdomena vaš sajt će biti aktivan pod istim.',
    choose_theme: 'Odaberite temu',
    view: 'Pogledaj',
    enter_company_details: 'Unesite podatke kompanije',

    progressbar: {
        create_step: 'Podaci o kompaniji',
        package_step: 'Odabir paketa',
        finish_step: 'Završni korak',
    },

    package_step: {
        title: 'Odaberite vaš paket',
        description: 'Počnite prvi mesec besplatno. Platna kartica nije potrebna.',
        monthly: 'Mesečno',
        yearly: 'Godišnje',
        button: 'POČNITE BESPLATNO',
        basic: {
            title: 'Osnovni',
            option1: 'Prvi mesec besplatan',
            option2: 'Neograničen broj usluga',
            option3: 'Neograničen broj rezervacija',
            option4: 'Neograničen broj radnika',
            option5: 'Neograničen broj lokacija',
            option6: 'Podešavanja neaktivnosti',
            option7: 'Konfiguracija profila',
            option8: 'Baza klijenata i mogućnost blokiranja korisnika',
        },
        pro: {
            title: 'Profesionalni',
            option1: 'Prvi mesec besplatan',
            option2: 'Neograničen broj usluga',
            option3: 'Neograničen broj rezervacija',
            option4: 'Neograničen broj radnika',
            option5: 'Neograničen broj lokacija',
            option6: 'Podešavanja neaktivnosti',
            option7: 'Konfiguracija profila',
            option8: 'Zaseban sajt za rezervacije za samo vašu kompaniju',
            option9: 'Konfiguracija vašeg sajta (odabir tema, slika, opisa)',
            option10: 'Subdomain sa vašim sajtom',
            option11: 'Nalepnica sa QR kodom',
            option12: 'Baza klijenata i mogućnost blokiranja korisnika',
        },
        invoice_info: 'Faktura se šalje svakog prvog u mesecu za prethodni mesec',
    },
}
